import routes from './stepLearningEngagementRoutes';

import StepLearningEngagementService from './services/stepLearningEngagementService';

import StepLearningEngagementComponent from './stepLearningEngagementComponent';
import AspectComponent from './pages/aspectComponent';
import AspectsMenuComponent from './aspectsMenu/aspectsMenuComponent';

const StepLearningEngagementModule = angular.module('app.stepLearningEngagement', [])
    .config(routes)
    .component('stepLearningEngagement', StepLearningEngagementComponent)
    .component('aspect', AspectComponent)
    .component('aspectsMenu', AspectsMenuComponent)
    .service('StepLearningEngagementService', StepLearningEngagementService);

export default StepLearningEngagementModule;



// WEBPACK FOOTER //
// ./src/app/pages/evaluation/pages/stepLearningEngagement/index.js